var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgLogo = function SvgLogo(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 347.29 347.29",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1, .cls-2 {\r\n        fill: #232e50;\r\n      }\r\n\r\n      .cls-1, .cls-3 {\r\n        opacity: 0.6;\r\n      }\r\n\r\n      .cls-4 {\r\n        fill: #1895b0;\r\n      }\r\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M260.47,173.65H201.33a27.68,27.68,0,0,0-27.68,27.68v59.14h86.82Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M86.82,260.47v59.14a27.69,27.69,0,0,0,27.69,27.68h59.14V260.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M260.47,260.47h59.14a27.68,27.68,0,0,0,27.68-27.68V173.65H260.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M347.29,173.65V114.51a27.69,27.69,0,0,0-27.68-27.69H260.47v86.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M173.65,347.29h59.14a27.68,27.68,0,0,0,27.68-27.68V260.47H173.65Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M86.82,173.65H146A27.69,27.69,0,0,0,173.65,146V86.82H86.82Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M260.47,86.82V27.68A27.68,27.68,0,0,0,232.79,0H173.65V86.82Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M86.82,86.82H27.68A27.69,27.69,0,0,0,0,114.51v59.14H86.82Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M0,173.65v59.14a27.68,27.68,0,0,0,27.68,27.68H86.82V173.65Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M173.65,0H114.51A27.69,27.69,0,0,0,86.82,27.68V86.82h86.83Z"
  })))))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgLogo);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "logo.3edfdde228471c321b3f3c21cab06c7f.svg";